<template>
    <div class="disable-popup">
        <div class="popup-content">
            <div class="box">
                <img class="tip" src="../images/tip.svg" />
                <div class="desc">
                    {{ _lang('uninstallPopupDescPrefix').replace(/\{name\}/, unInstallChannel) }}
                </div>
                <a class="share" @click="share">{{ _lang('uninstallPopupShare') }}</a>
            </div>
            <a class="close" @click="close"></a>
        </div>
    </div>
</template>

<script >
// 渠道不可用弹窗
import { computed } from 'vue-demi';
import { _lang } from '../common/lang';
import { Channel } from '../common/type';
import { useTeleport } from '../common/use';
const __sfc_main = {};
__sfc_main.props = {
  channel: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  !window.FEGOEditor && useTeleport(document.body);
  const props = __props;
  const emits = __ctx.emit;
  const unInstallChannel = computed(() => {
    // 分享渠道未安装时弹出的弹窗文案，朋友圈需要提示未安装微信而不是未安装朋友圈
    if (props.channel === Channel.WECHAT_MOMENTS) {
      return _lang(`names.${Channel.WECHAT}`);
    }
    return _lang(`names.${props.channel}`);
  });
  function share() {
    emits('share');
  }
  function close() {
    emits('close');
  }
  return {
    _lang,
    unInstallChannel,
    share,
    close
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.disable-popup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.popup-content {
    width: 5.6rem;
    .box {
        margin-bottom: 0.3rem;
        padding: 0.8rem 0.28rem 0.72rem;
        border-radius: 0.32rem;
        background-color: #fff;
        .tip {
            display: block;
            margin: 0 auto 0.16rem;
            width: 1.34rem;
            height: 1.34rem;
            background: url('../images/tip.svg') no-repeat center;
            background-size: contain;
        }
        .desc {
            margin-bottom: 0.48rem;
            min-height: 0.92rem;
            padding: 0.16rem 0;
            text-align: center;
            line-height: 0.6rem;
            font-size: 0.44rem;
            color: #262626;
        }
        .share {
            display: block;
            width: 100%;
            height: 0.8rem;
            background: #262626;
            border-radius: 0.4rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.3rem;
            color: #fff;
        }
    }
    .close {
        margin: 0 auto;
        display: block;
        width: 0.72rem;
        height: 0.72rem;
        background: url('../images/close.svg') no-repeat center;
        background-size: contain;
    }
}
</style>
